// extracted by mini-css-extract-plugin
export var redoItem = "_id-1";
export var redoTrigger = "_id-0";